function TodoForm({ task, deadline, onTaskChange, onDeadlineChange, onSubmit }) {
  return (
    <form
      className="form-box"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <div className="form-group">
        <label htmlFor="task">Tugas</label>
        <input
          id="task"
          type="text"
          placeholder="Contoh: Belajar React 1 jam"
          value={task}
          onChange={(e) => onTaskChange(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label htmlFor="deadline">Deadline</label>
        <input
          id="deadline"
          type="date"
          value={deadline}
          onChange={(e) => onDeadlineChange(e.target.value)}
        />
      </div>

      <button
        type="submit"
        className="primary-btn"
      >
        Tambah Tugas
      </button>
    </form>
  );
}

export default TodoForm;
